import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/blog-post.jsx";
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
export const pageQuery = graphql`
  query blogPostTemplateQuery($slug: String!) {
    site {
      ...LayoutFragment
      ...SEOFragment
      siteMetadata {
        siteUrl
      }
    }
    post: mdx(slug: { eq: $slug }) {
      id
      slug
      body
      excerpt
      rawBody
      frontmatter {
        datePublished(formatString: "YYYY-MM-DDTHH:mm:ssZ")
        lastUpdated(formatString: "YYYY-MM-DDTHH:mm:ssZ")
        postTitle
        seoMetaDescription
        featuredImageAlt
        bannerImage: featuredImage {
          ...BannerImageFragment
        }
      }
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <MDXRenderer mdxType="MDXRenderer">{props.data.post.body}</MDXRenderer>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      